import React, { useState, useEffect } from "react";
import cn from "classnames";
import Image from "next/image";
import useWindowWidth from "hooks/useWindowWidth";

const CustomerTrust = () => {
  const width = useWindowWidth();
  return (
    <div style={{ padding: width > 922 ? "80px 0" : "60px 0" }}>
      <div
        className={cn(
          "title_lg",
          "align_center",
          "font_extra-bold",
          "color_black"
        )}
      >
        Our customers trust us
      </div>
      <div
        style={
          width > 1250
            ? {
                display: "flex",
                marginTop: 60,
                alignItems: "center",
                justifyContent: "center",
                gap: 60,
              }
            : {
                display: "flex",
                flexDirection: "column",
                marginTop: 60,
                alignItems: "center",
                justifyContent: "center",
                gap: 16,
              }
        }
      >
        <div
          style={
            width > 700
              ? { display: "flex", alignItems: "center", gap: 25 }
              : {
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 25,
                  alignItems: "center",
                }
          }
        >
          <img
            src="/images/why-us/users_love.webp"
            alt="users love"
            width={width > 922 ? 120 : 77}
            height={width > 922 ? 140 : 97}
          />
          <img
            src="/images/why-us/high_performer.webp"
            alt="high performer"
            width={width > 922 ? 121 : 84}
            height={width > 922 ? 160 : 112}
          />
          <img
            src="/images/why-us/high_small.webp"
            alt="high performer"
            width={width > 922 ? 124 : 86}
            height={width > 922 ? 162 : 113}
          />
          <img
            src="/images/why-us/high_europe.webp"
            alt="high performer"
            width={width > 922 ? 121 : 85}
            height={width > 922 ? 134 : 94}
          />
        </div>
        <a href="https://www.capterra.com/p/236551/Apphud" target="_blank">
          <Image
            src="/images/why-us/capterra.webp"
            alt="users love"
            width={width > 922 ? 264 : 195}
            height={width > 922 ? 134 : 100}
          />
        </a>
        <a href="https://www.g2.com/products/apphud/reviews" target="_blank">
          <img
            src="/images/why-us/rating.webp"
            alt="users love"
            width={width > 922 ? 280 : 192}
            height={width > 922 ? 100 : 68}
          />
        </a>
      </div>
    </div>
  );
};

export default CustomerTrust;
